import { Button, Card, Col, message, Modal, Row, Typography, Spin } from "antd";
import React, { useEffect, useRef, useState } from "react";
import Get from "../../services/Get";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import Card1 from "../idCards/Card1";
import Card2 from "../idCards/Card2";
import Card3 from "../idCards/Card3";
import Card4 from "../idCards/Card4";
import CardDefault from "../idCards/CardDefault";
import ReactDOM from "react-dom";

const A4List = ({
  isModalVisible,
  setIsModalVisible,
  classFilter,
  sectionFilter,
}) => {
  const [cardsData, setCardsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [downloading, setDownloading] = useState(false);
  const [cardType, setCardType] = useState();

  const printRef = useRef();

  const onClose = () => {
    setIsModalVisible(false);
  };

  const handlePrint = async () => {
    setDownloading(true);
    const pdf = new jsPDF("p", "mm", "a4"); // A4 in portrait mode

    const marginX = 15; // Left margin
    const marginY = 10; // Top margin
    const gapX = 3; // Horizontal gap (for vertical cards)
    const gapY = 3; // Vertical gap

    let x = marginX;
    let y = marginY;
    let cardsPerPage = 0;

    const cardContainer = document.createElement("div");
    cardContainer.style.position = "absolute";
    cardContainer.style.left = "-9999px"; // Hide from viewport
    document.body.appendChild(cardContainer);

    const generateCardImage = async (card) => {
      cardContainer.innerHTML = ""; // Clear previous content
      const cardElement = document.createElement("div");
      cardContainer.appendChild(cardElement);

      ReactDOM.render(
        cardType == 1 ? (
          <Card1
            candidateName={card.data.name}
            studentAdmission={card.data.admission_no}
            mobile={card.data?.parent?.mobile}
            schoolMobile={card.data?.school.mobile}
            fathersName={card.data?.parent?.name}
            studentClass={card.data.class}
            studentSection={card.data.section}
            schoolName={card.data?.school.name}
            qrData={card.qr_code}
            profile={card.profile}
            logo={card.logo}
          />
        ) : cardType == 4 ? (
          <Card2
            candidateName={card.data.name}
            studentAdmission={card.data.admission_no}
            mobile={card.data?.parent?.mobile}
            schoolMobile={card.data?.school.mobile}
            fathersName={card.data?.parent?.name}
            studentClass={card.data.class}
            studentSection={card.data.section}
            schoolName={card.data?.school.name}
            qrData={card.qr_code}
            profile={card.profile}
            logo={card.logo}
          />
        ) : cardType == 3 ? (
          <Card3
            candidateName={card.data.name}
            studentAdmission={card.data.admission_no}
            mobile={card.data?.parent?.mobile}
            schoolMobile={card.data?.school.mobile}
            fathersName={card.data?.parent?.name}
            studentClass={card.data.class}
            studentSection={card.data.section}
            schoolName={card.data?.school.name}
            qrData={card.qr_code}
            profile={card.profile}
            logo={card.logo}
          />
        ) : cardType == 2 ? (
          <Card4
            candidateName={card.data.name}
            studentAdmission={card.data.admission_no}
            mobile={card.data?.parent?.mobile}
            schoolMobile={card.data?.school.mobile}
            fathersName={card.data?.parent?.name}
            studentClass={card.data.class}
            studentSection={card.data.section}
            schoolName={card.data?.school.name}
            qrData={card.qr_code}
            profile={card.profile}
            logo={card.logo}
          />
        ) : (
          <CardDefault
            candidateName={card.data.name}
            studentAdmission={card.data.admission_no}
            mobile={card.data?.parent?.mobile}
            schoolMobile={card.data?.school.mobile}
            fathersName={card.data?.parent?.name}
            studentClass={card.data.class}
            studentSection={card.data.section}
            schoolName={card.data?.school.name}
            qrData={card.qr_code}
            profile={card.profile}
            logo={card.logo}
          />
        ),
        cardElement
      );

      await new Promise((resolve) => setTimeout(resolve, 500)); // Wait for rendering

      const canvas = await html2canvas(cardElement, { scale: 2 });
      return {
        imgData: canvas.toDataURL("image/png"),
        width: canvas.width / 12, // Auto width
        height: canvas.height / 12, // Auto height
      };
    };

    const generatePDF = async () => {
      for (let index = 0; index < cardsData.length; index++) {
        const card = cardsData[index];
        const { imgData, width, height } = await generateCardImage(card);

        const isVertical = height > width; // Determine orientation

        if (isVertical) {
          // Vertical layout: 3 per row, multiple rows
          if (cardsPerPage % 3 === 0 && cardsPerPage !== 0) {
            y += height + gapY;
            x = marginX;
          }

          if (cardsPerPage === 9) {
            pdf.addPage();
            x = marginX;
            y = marginY;
            cardsPerPage = 0;
          }

          pdf.addImage(imgData, "PNG", x, y, width, height);
          x += width + gapX; // Move to the next column
        } else {
          // Horizontal layout: 1 per row, 3 per page
          if (cardsPerPage % 2 === 0 && cardsPerPage !== 0) {
            y += height + gapY;
            x = marginX;
          }

          if (cardsPerPage === 10) {
            pdf.addPage();
            x = marginX;
            y = marginY;
            cardsPerPage = 0;
          }

          pdf.addImage(imgData, "PNG", x, y, width, height);
          x += width + gapX; // Move to the next column
        }

        cardsPerPage++;
      }

      pdf.save("ID_Cards.pdf");
      setDownloading(false);
      document.body.removeChild(cardContainer);
    };

    generatePDF();
  };

  const getData = async () => {
    setIsLoading(true);
    try {
      const response = await Get.getAllStudents({ classFilter, sectionFilter });
      if (response.students) {
        setCardsData(response.students);
        setCardType(response.card_type);
      } else {
        message.error("Failed to fetch students data.");
      }
    } catch (error) {
      console.error(error);
      message.error("An error occurred while fetching students data.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [isModalVisible]);

  return (
    <Modal
      title="ID Cards"
      open={isModalVisible}
      onCancel={onClose}
      width={1250}
      footer={[
        <Button
          key="print"
          type="primary"
          disabled={downloading}
          className="form-btn"
          onClick={handlePrint}
          loading={downloading}
        >
          Download PDF
        </Button>,
        <Button key="close" onClick={onClose}>
          Close
        </Button>,
      ]}
    >
      <div
        style={{
          width: "310mm",
          minHeight: "297mm",
          padding: "20px",
          textAlign: "center",
          backgroundColor: "#f9f9f9",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
        }}
      >
        {isLoading ? (
          <Spin size="large" />
        ) : cardsData.length > 0 ? (
          <Row gutter={[24, 24]} justify="center">
            {cardsData.map((card, index) => (
              <Col
                span={12}
                key={index}
                style={{ display: "flex", justifyContent: "center" }}
              >
                {cardType == 1 ? (
                  <Card1
                    qrCodeRef={printRef}
                    logo={card.logo}
                    profile={card.profile}
                    candidateName={card.data.name}
                    studentAdmission={card.data.admission_no}
                    studentClass={card.data.class}
                    studentSection={card.data.section}
                    qrData={card.qr_code}
                    fathersName={card.data?.parent?.name}
                    schoolName={card.data?.school.name}
                    mobile={card.data?.parent?.mobile}
                    schoolMobile={card.data?.school.mobile}
                  />
                ) : cardType == 4 ? (
                  <Card2
                    qrCodeRef={printRef}
                    logo={card.logo}
                    profile={card.profile}
                    candidateName={card.data.name}
                    studentAdmission={card.data.admission_no}
                    studentClass={card.data.class}
                    studentSection={card.data.section}
                    qrData={card.qr_code}
                    fathersName={card.data?.parent?.name}
                    schoolName={card.data?.school.name}
                    mobile={card.data?.parent?.mobile}
                    schoolMobile={card.data?.school.mobile}
                  />
                ) : cardType == 3 ? (
                  <Card3
                    qrCodeRef={printRef}
                    logo={card.logo}
                    profile={card.profile}
                    candidateName={card.data.name}
                    studentAdmission={card.data.admission_no}
                    studentClass={card.data.class}
                    studentSection={card.data.section}
                    qrData={card.qr_code}
                    fathersName={card.data?.parent?.name}
                    schoolName={card.data?.school.name}
                    mobile={card.data?.parent?.mobile}
                    schoolMobile={card.data?.school.mobile}
                  />
                ) : cardType == 2 ? (
                  <Card4
                    qrCodeRef={printRef}
                    logo={card.logo}
                    profile={card.profile}
                    candidateName={card.data.name}
                    studentAdmission={card.data.admission_no}
                    studentClass={card.data.class}
                    studentSection={card.data.section}
                    qrData={card.qr_code}
                    fathersName={card.data?.parent?.name}
                    schoolName={card.data?.school.name}
                    mobile={card.data?.parent?.mobile}
                    schoolMobile={card.data?.school.mobile}
                  />
                ) : (
                  <CardDefault
                    qrCodeRef={printRef}
                    logo={card.logo}
                    profile={card.profile}
                    candidateName={card.data.name}
                    studentAdmission={card.data.admission_no}
                    studentClass={card.data.class}
                    studentSection={card.data.section}
                    qrData={card.qr_code}
                  />
                )}
              </Col>
            ))}
          </Row>
        ) : (
          <Typography.Text type="warning">No students found.</Typography.Text>
        )}
      </div>
    </Modal>
  );
};

export default A4List;
